import type { ComputedRef } from 'vue'
import { computed } from 'vue'

import { useTeamStore } from '@/pinia/useTeamStore'

import { usePlanStore } from './usePlanStore'
import { Resource } from './planTypes'

/**
 * Single source of truth for determining if the customer is gated from using TFA
 */
export const useResourceTFAEnforcement = (): { isTFAEnforcementGated: ComputedRef<boolean> } => {
  const planStore = usePlanStore()
  const teamStore = useTeamStore()

  const isTFAEnforcementGated = computed(() => {
    const plan = planStore.customerPlan
    if (plan) {
      // if on plan, then we only look at plan
      const license = plan.plan_licenses.find((l) => l.resource === Resource.TFA_ENFORCEMENT)
      return license?.limit === 0 && license?.is_blocking
    }

    // Rest are based off the legacy flag backend provides for us
    return !teamStore.currentTeam?.enforcing_two_factor_auth_allowed
  })

  return { isTFAEnforcementGated }
}
